<template>
  <g :transform="`translate(0, -${mapSize.depth})`">
    <rect x="0" y="1.8" width="1.5" height="1.5" fill="black" />
    <text x="2.2" y="3" font-size="1.2" font-weight="bold" text-anchor="start">
      {{ label }}
    </text>

    <defs>
      <linearGradient :id="gradientId" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop
          v-for="(stop, index) in gradientStops"
          :key="index"
          :offset="stop.offset"
          :stop-color="stop.color"
        />
      </linearGradient>
    </defs>

    <g :transform="`translate(${mapSize.width - mapSize.width / 3}, 0)`">
      <text x="0" y="1.2" font-size="1.2" text-anchor="start">
        {{ minValue }}{{ unit }}
      </text>
      <text :x="mapSize.width / 3" y="1.2" font-size="1.2" text-anchor="end">
        {{ maxValue }}{{ unit }}
      </text>

      <rect class="legend-gradient" y="1.8" :width="mapSize.width / 3" :height="1.5" :fill="`url(#${gradientId})`" />
    </g>
  </g>
</template>

<script>
import config from '@/config.js';

export default {
  props: {
    visualizationLayerType: {
      type: String,
      required: true
    },
    mapSize: {
      type: Object,
      required: true
    }
  },
  computed: {
    visualizationHeaderConfig() {
      return config.visualizationHeaders[this.visualizationLayerType];
    },
    colors() {
      return this.visualizationHeaderConfig['colors'];
    },
    label() {
      return this.visualizationHeaderConfig['label'];
    },
    unit() {
      return this.visualizationHeaderConfig['unit'];
    },
    minValue({ $store }) {
      if(this.visualizationLayerType === 'temperature') {
        return $store.state.visualization.layers['temperature'].minValue;
      }
      return this.visualizationHeaderConfig['minValue'];
    },
    maxValue({ $store }) {
      if(this.visualizationLayerType === 'temperature') {
        return $store.state.visualization.layers['temperature'].maxValue;
      }
      return this.visualizationHeaderConfig['maxValue'];
    },
    gradientStops() {
      const colorCount = this.colors.length
      const percentStep = 100 / colorCount
      const stops = []
      this.colors.forEach((color, i) => {
        const startOffset = i * percentStep
        const endOffset = (i + 1) * percentStep
        stops.push(
          { offset: `${startOffset}%`, color },
          { offset: `${endOffset}%`, color }
        )
      });
      return stops;
    },
    gradientId() {
      return `gradient-${this._uid}`;
    }
  }
}
</script>

<style scoped lang="scss">
.group1-layout .legend-gradient,
.group2-layout .legend-gradient,
.group3-layout .legend-gradient {
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// map_header.vue?98f70dd0